import { render, staticRenderFns } from "./CompanyPatentBar.vue?vue&type=template&id=2a56b54b"
import script from "./CompanyPatentBar.vue?vue&type=script&lang=js"
export * from "./CompanyPatentBar.vue?vue&type=script&lang=js"
import style0 from "./CompanyPatentBar.vue?vue&type=style&index=0&id=2a56b54b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports